import http from '../../../utils/fetch';
import updownfile from "../../../utils/updownfile";
export default {

    baseurl:'/api/swyl/v1/competitors/competitorsInfo',
    findComs(id){
        return http({
            url: this.baseurl + '/findComs',
            method: 'post',
            params: {'id':id}
        });
    },

    findComsnew(id){
        return http({
            url: this.baseurl + '/findComsnew',
            method: 'post',
            params: {'id':id}
        });
    },

    selectPage(q){
        return http({
            url: this.baseurl + '/selectPage',
            method: 'post',
            params: q
        });
    },

    selectCompetitorsInfo(q){
        return http({
            url: this.baseurl + '/getCompetitorsInfo',
            method: 'post',
            params: q
        });
    },

    getProGrowInfo(q){
        return http({
            url: this.baseurl + '/getProGrowInfo',
            method: 'post',
            params: q
        });
    },

    getCompAreaInfo(q){
        return http({
            url: this.baseurl + '/getCompAreaInfo',
            method: 'post',
            params: q
        });
    },


    downloadExcel(q){
        updownfile.down(this.baseurl+'/downloadExcel',q,"post","data");
    },





}